import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-chevron-left-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-chevron-left-svg-icon.component.html',
  styleUrl: './ln-chevron-left-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnChevronLeftSvgIconComponent {
  @Input({ required: true }) class!: string;
}
